<template>
  <v-overlay :opacity="0.6" v-model="dialog.show" z-index="6">
    <v-dialog v-model="dialog.show" :width="400" :height="isPopState ? 250 : 'auto'" :persistent="!dialog.alert"
      hide-overlay>
      <v-card rounded="sm">
        <div class="dialogShadow grey lighten-1"></div>
        <template v-if="dialog.alert">
          <v-card-title v-if='dialog.title' class="justify-center font-weight-bold py-3 pt-10">
            {{ dialog.title }}
          </v-card-title>
          <div class="px-5 pb-0 font-weight-bold text-center">
            <div v-html="dialog.content"
              :class="{ 'pt-6 d-flex text-center align-center justify-center': !dialog.title }">
            </div>
          </div>
        </template>
        <template v-else-if="dialog.error">
          <v-card-title v-if='dialog.title' class="justify-center font-weight-bold py-3">
            {{ dialog.title }}
          </v-card-title>
          <div class="px-5 pb-5 font-weight-bold text-center">
            <div v-html="dialog.content" :class="{ 'pt-6 d-flex align-center justify-center': !dialog.title }"></div>
            <v-row no-gutters>
              <v-spacer />
              <v-col cols="4" class="mt-5 text-center">
                <template v-if="!!dialog.outerLink">
                  <v-btn block outlined color="primary" rounded style="border: 2px solid" :href="dialog.outerLink"
                    @click="action()" target="3DOTP">
                    {{ dialog.button || $t('dialog_default_confirm') }}
                  </v-btn>
                </template>
                <template v-else>
                  <v-btn block outlined color="primary" rounded style="border: 2px solid" @click="action()">
                    {{ dialog.button || $t('dialog_default_confirm') }}
                  </v-btn>
                </template>
              </v-col>
              <v-spacer />
            </v-row>
          </div>
        </template>
        <template v-else>
          <v-card-title v-if="dialog.title" class="justify-center font-weight-bold py-3">
            {{ dialog.title }}
          </v-card-title>

          <div class="px-5 pb-5 font-weight-bold">
            <div v-html="dialog.content"></div>
            <v-row>
              <v-col :cols="dialog.buttons.length > 1 ? '6' : '12'" class="mt-5 text-center"
                v-for="(btn, i) in dialog.buttons">
                <v-btn :key="`dialog-button-${i}`" :depressed="btn.style.depressed" :block="btn.style.block"
                  :outlined="btn.style.outlined" :color="btn.style.color" @click="btnAction(btn.action)">
                  {{ btn.text || $t('dialog_default_confirm') }}
                </v-btn>
              </v-col>
            </v-row>
          </div>
        </template>
      </v-card>
    </v-dialog>
  </v-overlay>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters({
      dialog: "dialog/dialog",
      isPopState: "order/isPopState",
    }),
  },
  methods: {
    ...mapActions({
      closeDialog: "dialog/close",
    }),
    action() {
      if (!!this.dialog.redirectPathName) {
        this.$router.push({ name: this.dialog.redirectPathName }).catch(() => { });
      }
      if (!!this.dialog.action) {
        this.dialog.action();
      }
      setTimeout(() => {
        this.closeDialog();
      }, 500);
    },
    btnAction(act) {
      act();
      setTimeout(() => {
        this.closeDialog();
      }, 500);
    },
  },
};
</script>

<style lang="scss" scoped>
.theme--light.v-btn.v-btn--has-bg.primary,
.theme--light.v-btn.v-btn--has-bg.primary-1,
.theme--light.v-btn.v-btn--has-bg.primary {
  color: #fff !important;
}

::v-deep {
  .v-dialog .v-card {
    display: flex;
    flex-direction: column;
    min-height: 170px;

    >div.px-5.pb-5 {
      display: flex;
      flex-direction: column;
      flex: 1;
      flex-grow: 1;

      >div:first-child {
        flex: 1;
        flex-grow: 1;
      }

      >div.row {
        flex: 0;
      }
    }
  }
}

::v-deep.dialogShadow {
  height: 8px;
}
</style>
